import {NPA_ALERTS} from './messages';
import {HttpErrorResponse} from '@angular/common/http';

export const composeMessage = (error: HttpErrorResponse): string => {
    if (error && error.error && error.error.code) {
        // return NPA_ERRORS[lang][error.error.code];
        return NPA_ERRORS[error.error.code];
    } else {
        return NPA_ALERTS.prs.ERROR;
    }
};
export const NPA_ERRORS = {
    '|||NPA-USM-0001|||': 'تثبیت هویت ناموفق بود',
    '|||NPA-USM-0002|||': 'نام کاربر انتخابی شما در سیستم موجود می باشد',
    '|||NPA-USM-0004|||': 'شما به این بخش دسترسی ندارید',
    '|||NPA-AETS-0001|||': 'درج نمودن معلومات الزامیست!',
    '|||NPA-AETS-0002|||': 'دقت نمائید تاریخ آفرگشایی کوچکتر از تاریخ ضرب الاجل تسلیمی آفر میباشد!',
    '|||NPA-AETS-0003|||': 'لطفا اعضای هیئت آفرگشایی را انتخاب نمائید.',
    '|||NPA-AETS-0004|||': 'لطفا اعضای هیئت ارزیابی را انتخاب نمائید.',
    '|||NPA-AETS-0005|||': 'لطف نموده لات را انتخاب نمائید.',
    '|||NPA-AETS-0006|||': 'لطف نموده نوعیت فسخ را انتخاب نمائید.',
    '|||NPA-AETS-0007|||': 'دقت نمائید! معلومات این بخش ثبت نگردیده تا ارسال شود.',
    '|||NPA-AETS-0008|||': 'دقت نمائید! ضرب الاجل تسلیمی آفر به پایان رسیده است.',
    '|||NPA-AETS-0009|||': 'دقت نمائید! برای این پروسه تدارکاتی آفر بدیل صورت گرفته نمیتواند.',
    '|||NPA-AETS-0010|||': 'لطفا کاربر مورد نظر را به این روسه تدارکاتی انتخاب نمائید.',
    '|||NPA-AETS-0011|||': 'معلومات مورد نظر قبلاً ثبت گردیده است!',
    '|||NPA-AETS-0012|||': 'معلومات مورد نظر قبلاً ارسال گردیده است!',
    '|||NPA-AETS-0013|||': 'معلومات مورد نظر قبلاً منظور گردیده است!',
    '|||NPA-AETS-0014|||': 'معلومات مورد نظر قبلاً رد گردیده است!',
    '|||NPA-AETS-0015|||': 'معلومات مورد نظر ارسال نگردیده است!',
    '|||NPA-AETS-0016|||': 'معلومات مورد نظر قبلاً منظور گردیده است!',
    '|||NPA-AETS-0017|||': 'نظر به سلسله جریانات شما نمی توانید این کار را انجام دهید!',
    '|||NPA-AETS-0018|||': 'آفر اصلی ارایه گردیده است.',
    '|||NPA-AETS-0019|||': 'آفر بدیل ارایه گردیده است.',
    '|||NPA-AETS-0020|||': 'دقت نمائید! معلومات این بخش ثبت نگردیده تا منظور شود.',
    '|||NPA-AETS-0021|||': 'شما عضو هیئت آفرگشایی این پروسه تدارکاتی نمیباشید!',
    '|||NPA-AETS-0022|||': 'خطا در بارگذاری فایل کلید عامه (Public key)',
    '|||NPA-AETS-0023|||': 'بررسی آفرها از جانب شما تا حال تکمیل نگردیده است.',
    '|||NPA-AETS-0024|||': 'لطفا اعضای هیئت مذاکره قرارداد را انتخاب نمائید.',
    '|||NPA-AETS-0025|||': 'آفرگشایی فعلا صورت گرفته نمیتواند.',
    '|||NPA-AETS-0026|||': 'لطف نموده حداقل سه آفرگشا را انتخاب نمائید.',
    '|||NPA-AETS-0027|||': 'لطفا قبل از ارائه آفر، vPIN (شماره تشخیصیه تدارکاتی عرضه کننده) تان را دریافت کنید.',
    '|||NPA-AETS-0028|||': 'ارائه آفر به این داوطلبی محدود است زیراکه نوعیت تدارکات آن به شیوه داوطلبی مقید و یا منبع واحد میباشد.',
    '|||NPA-AETS-0029|||': 'کلید مخصوص (PFX) شما فعلا اپلود شده نمیتواند زیرا که آفرگشایی قبلا آغاز گردیده است',
    '|||NPA-AETS-0030|||': 'مدت ثبت اعتراض به نهاد ختم گردیده است.',
    '|||NPA-AETS-0031|||': 'دقت نمائید تاریخ ضرب الاجل تسلیمی آفر کوچکتر از تاریخ فعلی میباشد.',
    '|||NPA-AETS-PKI-0001|||': 'رمز ارایه آفر(otp) درست نمی باشد',
    '|||NPA-AETS-PKI-0002|||': 'public key آفر گشای مربوطه موجو نمی باشد.',
    '|||NPA-AETS-PKI-0004|||': 'خطا در بارگذاری فایل (PFX)',
    '|||NPA-AETS-PKI-0005|||': 'جفت کلید خصوصی / عمومی اشتباه میباشد',
    '|||NPA-AETS-PKI-0006|||': 'فایل کلید محرم و یا رمز آن اشتباه میباشد',
    '|||NPA-AETS-PKI-0007|||': 'آپلود فایل (PFX) نا موفق بود. لطفا دوباره کوشش نمایید',
    '|||NPA-AETS-PKI-0008|||': 'فایل کلید عامه اشتباه میباشد',
    '|||NPA-GENERIC-0003|||': 'این معلومات تکراری میباشد.'
};
